export default __webpack_public_path__ + "static/media/6t.41fe0812.jpg";